import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { for: "locale-switch" }

import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { LanguageIcon } from '@heroicons/vue/24/solid';
import UiButton from '@/components/ui/UiButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiLocaleSwitch',
  setup(__props) {

const { t, locale } = useI18n();

// Methods
const changeLanguage = (lang: string) => {
  localStorage.setItem('user-locale', lang);
  locale.value = lang;
};

// Lifecycle
onMounted(() => {
  const saved = localStorage.getItem('user-locale');
  if (saved) locale.value = saved;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiButton, {
    variant: "ghost",
    class: "px-2",
    "aria-label": "lang"
  }, {
    default: _withCtx(() => [
      _createElementVNode("label", _hoisted_1, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
          class: "bg-transparent text-sm text-gray-800 dark:text-white appearance-none",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage(_unref(locale))))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("option", { value: "en-US" }, [
            _createElementVNode("span", { class: "ml-2" }, "English")
          ], -1),
          _createElementVNode("option", { value: "pt-BR" }, [
            _createElementVNode("span", { class: "ml-2" }, "Português")
          ], -1)
        ]), 544), [
          [_vModelSelect, _unref(locale)]
        ])
      ])
    ]),
    _: 1
  }))
}
}

})